import { PaymentMethodState, PaymentMethodResponse } from './types'
import { createSlice } from '@reduxjs/toolkit'
import { getPaymentMethodList } from './paymentmethod.services';

export const initialState: PaymentMethodState = {
    data: {} as PaymentMethodResponse,
    status: "loading",
    error: {}
}

export const PaymentMethodSlice = createSlice({
    name: 'paymentmethod',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getPaymentMethodList.pending, (state) => {
                state.status = 'loading'
            })
            .addCase(getPaymentMethodList.fulfilled, (state, action) => {
                if (action.payload) {
                    state.data = action.payload.data;
                    state.status = action.payload.status;
                    state.error = action.payload.error
                }
            })
            .addCase(getPaymentMethodList.rejected, (state, action) => {
                state.status = 'error';
                state.error = action.error
            })
    }
})

export const PaymentMethodReducer = PaymentMethodSlice.reducer